import { jsx } from 'react/jsx-runtime';
import '../../../../components/StyleableSvgImage/index.mjs';
import '../../../proStoreCategories/index.mjs';
import { SiteId } from '../../../../contexts/MenuContext/mapping.mjs';
import '../../assets/applications.svg.mjs';
import '../../assets/Assets-V4/Gateways/ucg-fiber@2x.jpg.mjs';
import '../../assets/Consoles/ucgFiber.jpg.mjs';
import { gatewayCompact } from '../product-list-groups/gateways-compact.mjs';
import '../properties/index.mjs';
import { unifiAppSuite } from '../properties/unifiAppSuite.mjs';
import { throughput } from '../properties/throughput.mjs';
import { idsIpsThroughput } from '../properties/idsIpsThroughput.mjs';
import { managedUnifiDevices } from '../properties/managedUnifiDevices.mjs';
import { wanPorts } from '../properties/wanPorts.mjs';
import { lanPorts } from '../properties/lanPorts.mjs';
import { integratedWiFi } from '../properties/integratedWiFi.mjs';
import { storage } from '../properties/storage.mjs';
import { powerRedundancy } from '../properties/powerRedundancy.mjs';
import { mounting } from '../properties/mounting.mjs';
import v3Image__default from "../../../../assets/ucgFiber.jpg";
import image__default from "../../../../assets/ucg-fiber@2x.jpg";
import { UniFiCategoryId } from '../../../proStoreCategories/mapping/unifi.mjs';
import { StyleableSvgImage } from '../../../../components/StyleableSvgImage/StyleableSvgImage.mjs';
import applications__default from "../../../../assets/applications.svg";
"use strict";
const ucgFiber = {
  id: "ucgFiber",
  title: "ucgFiber.title",
  description: "ucgFiber.description",
  techspecsPath: [SiteId.TechSpecs, `/unifi/${UniFiCategoryId.CloudGateways}/ucg-fiber`],
  storePathParts: {
    productSlug: "ucg-fiber",
    category: "cloud-gateways-compact"
  },
  image: {
    src: image__default,
    width: 200,
    height: 140
  },
  v3Image: {
    src: v3Image__default,
    width: 317,
    height: 182
  },
  productListGroup: gatewayCompact,
  propertyValues: [{
    propertyId: "dimensions",
    value: {
      type: "string",
      value: '212.8 x 127.6 x 30 mm\n(8.3 x 5 x 0.5")'
    }
  }, {
    propertyId: unifiAppSuite.id,
    value: {
      type: "custom",
      value: /* @__PURE__ */jsx(StyleableSvgImage, {
        src: applications__default,
        height: 30,
        width: 144
      })
    }
  }, {
    propertyId: throughput.id,
    value: {
      type: "string",
      value: "10 Gbps"
    }
  }, {
    propertyId: idsIpsThroughput.id,
    value: {
      type: "string",
      value: "5 Gbps"
    }
  }, {
    propertyId: "licenseFreeNextAiSSLInspection",
    value: {
      type: "boolean",
      value: false
    }
  }, {
    propertyId: managedUnifiDevices.id,
    value: {
      type: "string",
      value: "50+"
    }
  }, {
    propertyId: "simultaneousUsersConnected",
    value: {
      type: "string",
      value: "500+"
    }
  }, {
    propertyId: wanPorts.id,
    value: {
      type: "translation",
      value: "ucgFiber.wanPorts"
    }
  }, {
    propertyId: lanPorts.id,
    value: {
      type: "translation",
      value: "ucgFiber.lanPorts"
    }
  }, {
    propertyId: "maxWanPortCount",
    value: {
      type: "string",
      value: "6"
    }
  }, {
    propertyId: "portLayout",
    value: {
      type: "string",
      value: "(4) 2.5 GbE RJ45\n(1) 10 GbE RJ45\n(2) 10G SFP+"
    }
  }, {
    propertyId: integratedWiFi.id,
    value: {
      type: "boolean",
      value: false
    }
  }, {
    propertyId: storage.id,
    value: {
      type: "translation",
      value: "ucgFiber.storage",
      asterisk: 1
    }
  }, {
    propertyId: powerRedundancy.id,
    value: {
      type: "boolean",
      value: false
    }
  }, {
    propertyId: "generalRedundancy",
    value: {
      type: "boolean",
      value: false
    }
  }, {
    propertyId: mounting.id,
    value: {
      type: "translation",
      value: "commons.mounting.desktop"
    }
  }]
  // Removing for now as its not clear what to attach this to
  // notes: ["ucgFiber.note.1"],
};
export { ucgFiber };
//# sourceMappingURL=ucgFiber.mjs.map
